import axios from 'axios'
import { ref, watch } from 'vue'
import { useArtistClaimProfileSteps } from './useArtistClaimProfileSteps'

const URLS = {
    xhr: {
        mutate: {
            claimProfile: '/api/profile/artist-claim-profile'
        }
    },
    redirect: {
        getStarted: '/profile/get-started'
    }
}

const load = ref(false)
const showClaimProfile = ref(false)
const userData = ref({
    email: '',
    first_name: '',
    last_name: '',
    password: ''
})
export const useArtistClaimProfile = () => {
    const { steps, step, currentStep, updateStep } = useArtistClaimProfileSteps()

    const showPassword = ref(false)

    const toggleClaimProfile = (state) => {
        if (state) {
            showClaimProfile.value = true
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
            document.body.classList.add('modal-open')
        } else {
            showClaimProfile.value = false
            document.body.classList.remove('modal-open')
        }
    }

    const skipFirstStep = (email) => {
        if (!email) return

        userData.value.email = email
        updateStep('info-step')
    }

    const sendData = async () => {
        try {
            load.value = true
            const response = await axios.post(URLS.xhr.mutate.claimProfile, {
                ...userData.value,
                password_confirmation: userData.value.password
            })

            if (response.data.data.success) {
                return true
            } else {
                return false
            }
        } catch (error) {
            console.error(error)
            return false
        } finally {
            load.value = false
        }
    }

    watch(
        () => showClaimProfile.value,
        (show, prevShow) => {
            if (!show && prevShow && currentStep.value.identifier === 'match-step') {
                window.location.href = URLS.redirect.getStarted
            }
        }
    )
    return {
        load,
        showClaimProfile,
        showPassword,
        userData,
        steps,
        step,

        updateStep,
        sendData,
        skipFirstStep,
        toggleClaimProfile
    }
}
